module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-2-1-8ef2c881826cdfeeb9391ada4f8e0967.jpg";